import { useContext } from 'react';
import { CreateCustomChartModal } from '@/modules/admin-dashboard/components/dashboard/custom-charts/CreateCustomChartModal.tsx';
import { InfoCard, ModalProviderContext } from 'ui';
import { PlusIcon } from 'ui/icons';

export const CreateCustomChartEmptyState = () => {
  const { openModal } = useContext(ModalProviderContext);

  const handleOpenCreateModal = () => {
    openModal(CreateCustomChartModal, {});
  };

  return (
    <InfoCard title="Add Custom Chart">
      <div
        className="w-full h-[264px] min-h-[250px] flex items-center justify-center cursor-pointer group"
        onClick={handleOpenCreateModal}
      >
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-gray-200 transition-colors">
            <img src={PlusIcon} alt="Add Chart" />
          </div>
          <p className="">Create a new custom chart</p>
        </div>
      </div>
    </InfoCard>
  );
};
